<div class="tree-container">
    <cw-treeview-item [data]="data.children" [multiSelection]="multiSelection" (selectedItem)="selectItem($event, true)"
        [iconSize]="iconSize" (itemCheckedChange)="onItemCheckedChange($event)" [isReadonly]="isReadonly">
    </cw-treeview-item>
</div>